@reference "@glow/tailwind-config/reference.css";

.checkbox {
  @apply inline-block;
  @apply relative;
  @apply w-5;
  @apply h-5;
  @apply select-none;
  @apply cursor-pointer;
}

.checkbox input {
  @apply absolute;
  @apply inset-0;
  @apply opacity-0;
  @apply appearance-none;
}

.checkbox input + span {
  @apply border;
  @apply border-2;
  @apply border-solid;
  @apply border-emphasis-medium;
  @apply block;
  @apply absolute;
  @apply inset-0;
  @apply rounded-sm;
}

.disabled {
  @apply opacity-30;
}

.checkbox input:checked + span {
  @apply border-transparent;
  @apply bg-emphasis-ultra;
  @apply text-primary-overlay-500;
}

.checkbox input:hover + span,
.checkbox input:focus + span {
  @apply outline-hidden;
  @apply ring-4;
  @apply ring-primary-100;
}

.checkbox input + span svg {
  @apply absolute;
  @apply opacity-0;
  @apply inset-0;
  @apply m-auto;
}

.checkbox input:checked + span svg {
  @apply opacity-100;
}
